export const Language = {
	ALL: 'All',
	EN: 'en',
	PL: 'pl',
}
